import { $ } from 'src/shared/js/utils/dom';
import AniScroll from 'src/shared/js/modules/ani-scroll';

const backToTopWrapper = $('.back-to-top');

if (backToTopWrapper) {
  const toTopButton = $('.back-to-top > button');
  const header = $('.header');
  const logo = $('.header__logo', header);

  function handleScroll() {
    const headerHeight = header.offsetHeight;

    if (window.scrollY >= headerHeight) {
      if (!backToTopWrapper.classList.contains('is-active'))
        backToTopWrapper.classList.add('is-active');
    } else {
      if (backToTopWrapper.classList.contains('is-active'))
        backToTopWrapper.classList.remove('is-active');
    }
  }

  function scrollToTop() {
    AniScroll(0, 500, 'easeOutQuad', () => {
      if (logo) {
        logo && logo.focus();
      }
    });
  }

  toTopButton.addEventListener('click', scrollToTop);
  document.addEventListener('scroll', handleScroll);
}
